import React from "react";
import { StyledCell } from "./styles";
import { Typography } from "@mui/material";

const ScheduleTableMonthHeader = ({ months = [] }) => {
  const sxA = {
    position: "absolute",
    top: 0,
    left: "12px",
    bottom: 0,
    margin: "auto",
    height: "20px",
  };
  const sxF = {
    ...sxA,
    position: "fixed",
    top: "101px",
    left: "342px",
    margin: "0px",
  };

  return (
    <>
      {months?.map(({ label, span }, idx) => (
        <StyledCell
          className="schedule-month-cell"
          key={label}
          colSpan={span}
          sx={{ position: "relative", height: "33px" }}
        >
          <Typography variant="caption" sx={idx ? sxA : sxF}>
            {label}
          </Typography>
        </StyledCell>
      ))}
    </>
  );
};

export default ScheduleTableMonthHeader;
